import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { CustomerRecord } from '../entities/records';
import * as selectors from '../entities/Customer/selectors';

function mapStateToProps(state, { customersIds }) {
  return {
    customers: selectors.customersByIds(state, customersIds),
  };
}

export default compose(
  setPropTypes({
    customersIds: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    customers: PropTypes.instanceOf(CustomerRecord),
  }),
)(mapStateToProps);
